import React from "react"
import PropTypes from "prop-types"
import sprite from "../images/icon_sprite.svg"

const Sprite = ({ icon, width, height, className }) => {
  return (
    <svg width={width} height={height !== undefined ? height : width} className={className}>
      <use href={`${sprite}#icon-${icon}`}/>
    </svg>
  )
}

Sprite.propTypes = {
    icon: PropTypes.string.isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
    className: PropTypes.string,
}

export default Sprite
